import {
  adjustDefaultParams,
  getDataAndCountFromResponse,
  getQueryForAllAndCount,
  handleSilentApiError,
  newDictToStringParam,
} from "./utils"
import { ENDPOINT, axios } from "./constants"

const ITEM_DETAIL_QUERY = `
  idDeliveryNote
  status
  customerId
  currencyId
  attnName
  address
  phone
  fax
  deliveryDate
  poDate
  poNumber
  preparedById
  notes
  dnNumber
  isTemporary
  temporaryDnNumber
  currency {
    code
    description
    idCurr
  }
  relatedInvoice {
    edges {
      node {
        status
      }
    }
  }
  customer{
    idCust
    custCode
    name
    address
    phoneNumber
    faxNumber
    email
    destinationList {
      destination
    }
  }
  preparedBy{
    idUser
    name
    employeeNumber
  }
  signedBy {
    idUser
    name
    employeeNumber
  }
  productDetails{
    idDnDetail
    description
    quantity
    unit
    remarks
    salesEstimateId
    mouldCode
    unitPrice
    sequence
    relatedInvoiceDetail {
      edges {
        node {
          idInvoiceDetail
          invoice {
            status
          }
        }
      }
    }
    salesEstimate {
      handling
      reductionHistory
      quantity
      description
      quantity
      idSalesEstimate
      uom {
        name
      }
      slsPurchaseOrder {
        poNumber
        poDate
      }
      relatedWorkOrderEstimate {
        edges{
          node {
            idWorkOrderEstimate
            workOrder {
              woNumber
            }
            mouldCode
            status
          }
        }
      }
      slsQuot {
        poNumber
        slsQuotDate
        slsQuotNumber
        poDate
      }
      estQuot {
        rfq {
          image
        }
        processCostHandling
        materialCostHandling
        additionalCostHandling
        processCosts {
          id
          time
          processId
          process {
            cost
          }
        }
        materialCosts {
          materialId
          dimension
          quantity      
          sequence
          unitPrice
          material {
            materialCode
            unitPrice
            dimension
            materialType {
              density
              name
            }
          }
        }
        additionalCosts {
          quantity
          process
          cost
          handling
        }
      }
    }
  }
  `

export default class ApiDeliveryNotes {
  static async get(inpParams = {}) {
    const params = adjustDefaultParams(inpParams)
    let query = `
      query {
        allDeliveryNoteImpl {
            ${ITEM_DETAIL_QUERY}
        }
      }`
    query = getQueryForAllAndCount(query, params)

    const response = await axios.post(ENDPOINT.QUERY, {
      query,
    })
    handleSilentApiError(response)
    return getDataAndCountFromResponse(response)
  }

  static async getItem(id) {
    const response = await axios.post(ENDPOINT.QUERY, {
      query: `
          query { 
            getDeliveryNoteImpl (idDeliveryNote: ${id}) {
              ${ITEM_DETAIL_QUERY}
            }
          }`,
    })
    handleSilentApiError(response)

    return { data: response.data.data.getDeliveryNoteImpl }
  }

  static async create(payload) {
    const payloadAsParam = newDictToStringParam(payload)
    const response = await axios.post(ENDPOINT.CREATE, {
      query: `
        mutation {
        saveDeliveryNoteImpl(${payloadAsParam}) {
            deliveryNoteImpl {
              ${ITEM_DETAIL_QUERY}
            }
          }
      }`,
    })
    handleSilentApiError(response)

    return {
      data: response.data.data.saveDeliveryNoteImpl.deliveryNoteImpl,
    }
  }

  static async update(id, payload) {
    const payloadAsParam = newDictToStringParam({
      ...payload,
      idDeliveryNote: parseInt(id, 10),
    })
    const response = await axios.post(ENDPOINT.UPDATE, {
      query: `
        mutation {
          updateDeliveryNoteImpl (${payloadAsParam}) {
            deliveryNoteImpl{
              ${ITEM_DETAIL_QUERY}
            }
          }
        }`,
    })
    handleSilentApiError(response)

    return {
      data: response.data.data.updateDeliveryNoteImpl.deliveryNoteImpl,
    }
  }

  static async getConfig() {
    const response = await axios.post(ENDPOINT.QUERY, {
      query: `
      query {
        getDeliveryNoteConfigImpl {
          poFilter
          isRunningNumber
        }
      }`,
    })
    handleSilentApiError(response)
    return { data: response.data.data.getDeliveryNoteConfigImpl }
  }

  static async getDeliveryNoteYear() {
    const response = await axios.post(ENDPOINT.QUERY, {
      query: `
      query {
        allDeliveryNoteYearImpl
      }`,
    })

    handleSilentApiError(response)

    return {
      data: response.data.data.allDeliveryNoteYearImpl,
    }
  }
}
